jQuery(document).ready(function ($) {
	$('.process-step__title').click(function (event) {
    event.preventDefault();
    _this = this;
    $target = $(_this).next();
    $target.slideToggle();
    $(_this).toggleClass('is-open');

		// Trigger
		$trigger = $(_this).find('[data-style="trigger"]');
    $trigger_label = $trigger.attr('data-label');
    $trigger_label_opened = $trigger.attr('data-label-opened');
		$trigger.toggleClass('is-open');
		toggleLabel($trigger, $trigger_label, $trigger_label_opened);
		
  });

	var toggleLabel = function ($trigger, $trigger_label, $trigger_label_opened){
    if($($trigger).hasClass('is-open')){
      $($trigger).find('.label').text($trigger_label_opened);
    } else {
      $($trigger).find('.label').text($trigger_label);
    }
  };


});